import React from "react";
import { Card, CardHeader } from "reactstrap";

import FormContents from "./Module/FormContents";

const ContactForm = () => {
  return (
    <div>
      <Card className="mb-2 org_contentarea">
        <div className="org_subtitle_sec">
          <h4 className="org_subtitle">お問い合わせ</h4>
        </div>

        <FormContents />
      </Card>
    </div>
  );
};

export default ContactForm;
